import React from "react";
import AccessCutoffOverrider from "../cutoffs/AccessCutoffOverrider";

const EventAccessAndCutoff = ({ accessOverride, setAccessOverride, cutoffOverride, setCutoffOverride, timezone }) => (
  <>
    <div>
      <AccessCutoffOverrider override={accessOverride} setOverride={setAccessOverride} timezone={timezone} />
    </div>
    <div className="bcr-mt-2">
      <AccessCutoffOverrider
        override={cutoffOverride}
        setOverride={setCutoffOverride}
        timezone={timezone}
        isCutoff={true}
      />
    </div>
  </>
);

export default EventAccessAndCutoff;
